import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { AccountChangeHistoriesRoute } from '../../routing'

export  class AccountChangeHistoriesPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <AccountChangeHistoriesRoute />
        </Fragment>
        )
    }
}